module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAASklEQVQ4jWNgGBxAI+M/Ot7PZUAQYxgQVTIXbgAxAMWAzMZlYEGYISS7QN2z/r99bO9/RZca8lxAURgQZR0+FxBj26gLCKWDIQ0A+AWkW2eyYVUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/LR.png
// module id = 1194
// module chunks = 0